import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop Component
 *
 * Automatically scrolls the window to the top whenever the route changes.
 * Includes a small delay to prevent breaking animations (Framer Motion, AOS, GSAP).
 *
 * Usage: Place inside BrowserRouter/Router, before Routes component.
 */
export function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Small delay to ensure animations initialize properly
    const timeoutId = setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant", // Instant scroll without smooth animation
      });
    }, 50);

    // Cleanup timeout on component unmount to prevent memory leaks
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  // Component returns null - it's just a side-effect component
  return null;
}

export default ScrollToTopOnRouteChange;
